module.exports = __webpack_public_path__ + "static/media/payment_method_success_icon.20a1b733.svg";